// extracted by mini-css-extract-plugin
module.exports = {"wrapperes":"playButton_wrapperes__2RU_X","anchor":"playButton_anchor__2w8fc"};